// getCurrentEngine.js
'use strict';

import createCachedSelector from '../resource/createCachedSelector.js';
import { VOD_PLAYER_ENGINE } from '../RemoteConfigKeys.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

const PlayerEngine = Object.freeze({
  SHAKA: 'shaka',
  PRESTOPLAY: 'prestoplay',
});

/** Select the active VOD player engine from remote config; defaults to prestoplay. */
const getCurrentEngine = createCachedSelector(
  state => getRemoteConfigData(state, VOD_PLAYER_ENGINE),
  engine => {
    const normalized =
      typeof engine === 'string' ? engine.trim().toLowerCase() : '';

    return normalized === PlayerEngine.SHAKA
      ? PlayerEngine.SHAKA
      : PlayerEngine.PRESTOPLAY;
  }
)(() => 'getCurrentEngine');

export { PlayerEngine };
export default getCurrentEngine;
